<template>
  <v-toolbar flat class="d-sm-none" color="transparent">
    <v-progress-linear
      indeterminate
      absolute
      top
      :active="$store.state.page_loader"
      color="white"
      background-color="primary"
    ></v-progress-linear>
    <v-app-bar-nav-icon @click="$router.go(-1)">
      <v-icon>{{ mdiArrowLeft }}</v-icon>
    </v-app-bar-nav-icon>
    <v-toolbar-title v-if="title">{{ title }}</v-toolbar-title>
    <slot />
  </v-toolbar>
</template>

<script>
import { mdiArrowLeft } from "@mdi/js";

export default {
  props: {
    title: { type: String, default: "" }
  },

  data() {
    return {
      mdiArrowLeft
    };
  }
};
</script>
